import React, {useState} from 'react';
import { useEffect } from 'react';

const SwitchType = ({selectedItem,handlePostData, action}) => {
	// selectedItem.deviceState
	const [switches, setSwitches] = useState(selectedItem.deviceState);
	const [getLength, setLength] = useState(0);
	
	useEffect(()=> {
		let power = 0;
		Object.keys(switches).map(_ => power++);
		setLength(power);
		if(selectedItem.deviceState !== switches){
			setSwitches(selectedItem.deviceState)
			let power = 0;
			Object.keys(switches).map(_ => power++);
			setLength(power);
		}
	}, [switches, selectedItem.deviceState])

	const handlePower = (key) => {
		switches[key] = !switches[key]; 
		handlePostData(key, switches[key])
		action();
	}

	const handleAllOn = () => {
		Object.keys(switches).forEach((key, i) => {
			switches[key] = true
		});
		handlePostData(null ,switches, "AllSwitches")
		action();
	}

	const handleAllOff = () => {
		Object.keys(switches).forEach((key, i) => {
			switches[key] = false
		})
		handlePostData(null ,switches, "AllSwitches")
		action();
	}

	return (
		<section className="device-setting-body">
			<div className="device-display switches">
				<div className={`display switch-${getLength}`}>
					{Object.keys(switches).map((key, i) => 
					<p key={i} onClick={()=> handlePower(`power${i+1}`)} 
					className={`switch ${switches[key] ? "active" : ""}`}>
					<span>{i+1}구</span></p>)}
				</div>
			</div>

			<div className="device-control-wrap">
				<div className="device-control device-control-flex">
					<p onClick={handleAllOn} className="switch-button">
						<span>모두 켜기</span>
					</p>
					<p onClick={handleAllOff} className="switch-button">
						<span>모두 끄기</span>
					</p>
				</div>
			</div>
		</section>
	);
}

export default SwitchType;